import React, { useEffect, useState } from 'react';
import styles from '../../styles.module.scss'
import * as apis from '../../utils/apis';
import OrganizationNode from '../orgranization/organization-node';
import { useVendorPointSolutionContext } from '../vendor-solution-provider';

const OrganizationTree = props => {
  const {
    selectedOrgSearch
  } = useVendorPointSolutionContext();

  const [orgParent, setOrgParent] = useState(null);
  const [org, setOrg] = useState(null);

  useEffect(() => {
    selectedOrgSearch && fetchOrganization();
  }, [selectedOrgSearch]);

  const fetchOrganization = async () => {
    const {
      organization_id
    } = selectedOrgSearch;

    const org = await apis.fetchOrganizationById(organization_id)
    const orgParent = await apis.fetchOrganizationParentById(organization_id);

    setOrgParent(orgParent);
    setOrg(org);
  }

  return org && (
    <div id='organization-tree'>
      <h3>Details for {org.organization_nm}</h3>
      <span className={styles.treeInstruction}>
        Click an organization to toggle its children
      </span>
      {orgParent && <a className={styles.orgName}>{orgParent.organization_nm}</a>}
      <OrganizationNode org={org} {...props}/>
    </div>
  );
};

export default OrganizationTree;
